import React from 'react';
import { Alert, Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import CommonTagsInputWrapper from '../common/CommonTagsInputWrapper';
import { personsActions } from '../../behavior/persons';

const ReplacePicker = ({ formikProps }) => {
  const { t } = useTranslation();

  const fromValue = formikProps.values.replaceFromPerson || null;
  const toContact = (formikProps.values.contacts && formikProps.values.contacts[0]) || null;
  const toValue = toContact && toContact.person ? toContact.person : null;
  const toNotAtCern = !!toValue && toValue.atCern === 'N';

  const setTo = (_name, person) => {
    formikProps.setFieldValue('contacts', person ? [{ person }] : []);
  };

  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      spacing={2}
      alignItems={{ xs: 'stretch', md: 'flex-end' }}
      sx={{ mt: 1 }}
    >
      <Box sx={{ flex: 1, minWidth: 220 }}>
        <Typography variant="caption" sx={{ display: 'block', mb: 0.5 }}>
          {t('batch.update.contacts.replace.from.label')}
        </Typography>
        <CommonTagsInputWrapper
          name="replaceFromPerson"
          setFieldValue={formikProps.setFieldValue}
          dynamicSuggestionListAction={(v) =>
            personsActions.getPersonAutocompleteListAction(v, false, true, true)
          }
          matchProperty="name"
          displayProps="name"
          value={fromValue}
          maxTags={1}
          onlyUnique={true}
        />
      </Box>
      <Box sx={{ pb: 1, fontWeight: 600, alignSelf: 'center' }}>→</Box>
      <Box sx={{ flex: 1, minWidth: 220 }}>
        <Typography variant="caption" sx={{ display: 'block', mb: 0.5 }}>
          {t('batch.update.contacts.replace.to.label')}
        </Typography>
        <CommonTagsInputWrapper
          name="__replaceTo"
          setFieldValue={setTo}
          dynamicSuggestionListAction={(v) =>
            personsActions.getPersonAutocompleteListAction(v, false, true, true)
          }
          matchProperty="name"
          displayProps="name"
          value={toValue}
          maxTags={1}
          onlyUnique={true}
        />
        {toNotAtCern && (
          <Alert severity="error" sx={{ mt: 1 }}>
            {t('batch.update.contacts.replace.to.not.at.cern.error')}
          </Alert>
        )}
      </Box>
    </Stack>
  );
};

export default ReplacePicker;
